export default __webpack_public_path__ + "static/media/star-fill-gray5-24.b7a0098e.svg";